import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataVk: [],
  newVk: null,
  activeVk: localStorage.getItem("dataVk")
    ? JSON.parse(localStorage.getItem("dataVk"))
    : null,
  updateVk: false,
  updateVkData: {},
  isLoadingVk: false,
  isConnectedVk: false,
  isErrorVk: false,
};

const vkSlice = createSlice({
  name: "vk",
  initialState,
  reducers: {
    setDataVk(state, action) {
      state.dataVk = action.payload;
    },
    setNewVk(state, action) {
      state.newVk = action.payload;
    },
    setActiveVk(state, action) {
      state.activeVk = action.payload;
    },
    setUpdateVk(state, action) {
      state.updateVk = action.payload;
    },
    setUpdateVkData(state, action) {
      state.updateVkData = action.payload;
    },
    setIsLoadingVk(state, action) {
      state.isLoadingVk = action.payload;
    },
    setIsConnectedVk(state, action) {
      state.isConnectedVk = action.payload;
    },
    setIsErrorVk(state, action) {
      state.isErrorVk = action.payload;
    },
  },
});

export const {
  setDataVk,
  setNewVk,
  setActiveVk,
  setUpdateVk,
  setUpdateVkData,
  setIsLoadingVk,
  setIsConnectedVk,
  setIsErrorVk,
} = vkSlice.actions;

export default vkSlice.reducer;
